import React from 'react';
import { inject, observer } from 'mobx-react';
import { jumpTo } from '@/navigate';
import './index.scss';
import BgAudio from "./bgAudio";
import scene from '../three/index';
import ImageAnim from "../../components/imageAnim";
import Loader from '../three/loader';
import http from '@/services/http';

@inject('ScoreStore')
@observer

class App extends React.Component {
    state = {

    }

    componentDidMount() {
        Loader.loadImageAnim();

        let s = scene;
        s.init(this.refs.container, () => {
            s.changeState(1, {
                dachangyu: this.refs.dachangyu,
                qimen: this.refs.qimen,
                sanyinjiao: this.refs.sanyinjiao,
                taichong: this.refs.taichong,
                tianshu: this.refs.tianshu,
                shenque: this.refs.shenque,
                shangjuxu: this.refs.shangjuxu
            });
        });
        this.threescene = s;

        this.xlabUploadScore();
    }

    penaltiesRender() {
        let data = this.props.ScoreStore.penalties;
        if (data.length > 0) {
            let item = data.map((item, index) => {
                return (<div key={index} className="score_list_item"><span>{item.name}</span><span>-{item.score}</span></div>)
            })
            return (
                <div className="score_list_view">
                    <div className="un_score">未得分项</div>
                    <div className="un_score_view">
                        {item}
                    </div>
                </div>
            )
        }
        else {
            return null;
        }
    }
    restart() {
        this.props.ScoreStore.reStart();
        jumpTo('guide1')
    }
    xlabUploadScore() {
        let score = this.props.ScoreStore.score;
        let loginToken = localStorage.getItem('loginToken');
        if (loginToken && loginToken != 'undefined') {
            let startTime = localStorage.getItem("startDate");
            startTime = parseInt(startTime);
            http.ilabxUpload({ experimentName: "针灸适宜病症诊疗思维与技能交互训练", machineScore: score, examTime: parseInt((Date.now() - startTime) / (1000 * 60)), detailsInfomation: "" }).then(ret => {
                console.log(ret);
            });
        }
    }

    render() {
        return (
            <div className="page page-guide guide_room_3">
                <div className="threescene" ref="container"></div>

                <ImageAnim name="dachangyu" ref="dachangyu" />
                <ImageAnim name="qimen" ref="qimen" />
                <ImageAnim name="sanyinjiao" ref="sanyinjiao" />
                <ImageAnim name="taichong" ref="taichong" />
                <ImageAnim name="tianshu" ref="tianshu" />
                <ImageAnim name="shenque" ref="shenque" />
                <ImageAnim name="shangjuxu" ref="shangjuxu" />

                <div className={"right_container"}>
                    <div className="score_view">
                        <div className="score_tit">实验得分</div>
                        <div className="score"><strong>{this.props.ScoreStore.score}</strong>分</div>
                        <div className="total_score">总分：100</div>
                    </div>
                    {this.penaltiesRender()}
                    <div className="button replay_btn" onClick={() => this.restart()}>
                        <span>再来一遍</span>
                        <img src={require('../../assets/images/right.png')} />
                    </div>
                </div>
                <BgAudio />
            </div>
        );
    }
}

export default App;
